export default __webpack_public_path__ + "static/media/1187.6c8dc1f1.png";